import { gql } from "urql";
export const CreatePriorityNoteMutation = gql `
    mutation CreatePriorityNote($input: PriorityNoteCreate!) {
        priorityNotes {
            createPriorityNote(input: $input) {
                priorityNoteId
                priorityEntryId
                organizationId
                note
                noteType
                contactType
                contactReason
                contactOutcome
                name
                imageUrl
                createdAt
            }
        }
    }
`;
